const DOCUMENT_URL = 'https://docs.google.com/document/d/1ta59ROEAOWewXOLGF9fx7v1oCIf6Op3Iaa1eKvMGW-o?rm=minimal'

const DocumentIFrame = () => <iframe title="Document" height="100%" width="100%" src={DOCUMENT_URL} />

export default DocumentIFrame
